const handleReopenActionFormActions = {
  confirm: '¿Realmente quiere reabrir esta acción?',
  title: 'REABRIR ACCIÓN',
  newStatus: 'En proceso'
};

export default handleReopenActionFormActions;
